import { t } from "i18next"
import {
  AFFILIATE_PATH,
  AFFILIATE_TASK_PATH,
  AI_CALL_ANALYSIS_REPORT_PATH,
  CALL_RECORDING_PATH,
  CLIENT_LISTING_PATH,
  LEADS_LISTING_PATH,
  LEADS_SHARED_LISTING_PATH,
  QUALITY_CONTROL_PATH,
  TASKS_LISTING_PATH,
  TODOS_LISTING_PATH,
  TSR_LISTING_PATH,
  CONTRACT_PATH,
  SALES_PIPELINE,
} from "./app-paths"
import theme from "utils/themeVars"
import { configs } from "../configs"

export const projectType = () => [
  { key: 1, label: t("Exclusive"), value: "exclusive" },
  { key: 2, label: t("Non-Exclusive"), value: "non_exclusive" },
]

export const genderList = () => [
  { id: 1, label: t("Male"), slug: "male" },
  { id: 2, label: t("Female"), slug: "female" },
  { id: 3, label: t("Others"), slug: "other" },
]

export const selectionType = () => [
  { key: 1, label: t("On"), value: "on" },
  { key: 2, label: t("Off"), value: "off" },
]

export const genericSelectionType = () => [
  { label: t("Yes"), value: "true" },
  { label: t("No"), value: "false" },
]

export const clientClassOptions = () => [
  { label: t("Direct"), value: "direct" },
  { label: t("Affiliate"), value: "affiliate" },
]

export const affiliateOptions = () => [
  { label: t("MOU ID"), value: "mouId" },
  { label: t("Affiliate ID"), value: "id" },
  { label: t("CRM ID"), value: "crmId" },
]

// Array with values {id}-{leadSide}
export const secondaryLeadPurpose = () => [
  { label: t("Buy"), value: "1-demand" },
  { label: t("Sell"), value: "1-supply" },
  { label: t("Rent In"), value: "2-demand" },
  { label: t("Rent Out"), value: "2-supply" },
]

export const propertyTypes = () => [
  { id: 1, label: t("Home"), slug: "home" },
  { id: 2, label: t("Plots"), slug: "plots" },
  { id: 3, label: t("Commercial"), slug: "commercial" },
  { id: 4, label: t("Apartments"), slug: "apartments" },
]

export const leadTypes = type => {
  let leadTypes = [
    { id: 1, label: t("Primary"), value: "primary" },
    { id: 2, label: t("Secondary"), value: "secondary" },
    { id: 3, label: t("Bank Loan"), value: "mortgage" },
    { id: 5, label: t("Investment"), value: "investment" },
  ]
  if (type === "lms") leadTypes.push({ id: 4, label: t("Advertisement"), value: "advertisement" })
  return leadTypes
}

export const teamTypes = () => [
  { id: 1, label: t("Sales-Primary"), slug: t("Sales-Primary"), value: "sales" },
  { id: 2, label: t("Sales-Secondary"), slug: t("Sales-Secondary"), value: "secondarySales" },
  { id: 3, label: t("Support"), slug: "support", value: "support" },
]

export const taskTypes = () => [
  { id: 1, label: t("Meeting"), slug: "meeting", value: "meeting" },
  { id: 2, label: t("Call"), slug: "call", value: "call" },
  { id: 3, label: t("Sales"), slug: "sales", value: "sales" },
]

export const timeFormats = () => [
  { label: t("12 hours"), value: "12" },
  { label: t("24 hours"), value: "24" },
]

export const callByList = () => [
  { value: "prop_go", label: t("Propgo") },
  { value: "whatsapp", label: t("Whatsapp") },
  { value: "dubai_pbx", label: t("DubaiPBX") },
  { value: "stealth", label: t("Stealth") },
  { value: "intellicon", label: t("Intellicon") },
  ...(configs?.allowGrandStreamCall ? [{ value: "grandstream", label: t("GrandStream") }] : []),
]

export const roleTypes = () => [
  { label: t("Default Role"), value: "default" },
  { label: t("Special Role"), value: "special" },
]

export const projectTypes = () => [
  { label: t("Active"), value: "on" },
  { label: t("Inactive"), value: "off" },
]

export const meetingVenue = () => [
  { label: t("Company Office"), value: "company_office" },
  { label: t("Site Office"), value: "site_office" },
  { label: t("Out Door"), value: "out_door" },
  { label: t("Sale Event"), value: "sale_event" },
]

export const meetingProbability = () => [
  { label: t("High"), value: "high" },
  { label: t("Medium"), value: "medium" },
  { label: t("Low"), value: "low" },
]

export const calenderFiltersList = () => [
  { label: t("My Meetings"), value: "myMeeting" },
  { label: t("TSR Meetings"), value: "tsrMeeting" },
  { label: t("Sales"), value: "sale" },
  { label: t("Busy"), value: "busy" },
]

export const inActivityDays = () => [
  { label: t("5 days"), value: "5" },
  { label: t("15 days"), value: "15" },
  { label: t("25 days"), value: "25" },
  { label: t("30 days"), value: "30" },
  { label: t("60 days"), value: "60" },
  { label: t("90 days"), value: "90" },
  { label: t("120 days"), value: "120" },
  { label: t("240 days"), value: "240" },
]

export const RoutesMappings = {
  leads: LEADS_LISTING_PATH,
  calls: CALL_RECORDING_PATH,
  tasks: TASKS_LISTING_PATH,
  clients: CLIENT_LISTING_PATH,
  leadsShared: LEADS_SHARED_LISTING_PATH,
  qualityControl: QUALITY_CONTROL_PATH,
  affiliate_tasks: AFFILIATE_TASK_PATH,
  affiliates: AFFILIATE_PATH,
  telesales: TSR_LISTING_PATH,
  todos: TODOS_LISTING_PATH,
  "ai-call-analysis": AI_CALL_ANALYSIS_REPORT_PATH,
  contracts: CONTRACT_PATH,
  pipeline:SALES_PIPELINE
}
export const units = () => [
  { label: t("% Age"), value: "percentage" },
  { label: t("Amount"), value: "amount" },
]

export const ratingArray = () => [
  { id: 4, label: t("Excellent"), color: theme["primary-color"] },
  { id: 3, label: t("Good"), color: theme["accent-color"] },
  { id: 2, label: t("Average"), color: theme["average-color"] },
  { id: 1, label: t("Need Improvement"), color: theme["error-color"] },
]

export const reportCategories = {
  movementReport: {
    name: "Movement",
    key: "staff-movement",
  },
  saleskpi: {
    name: "KPI Sales",
    key: "kpi-sales",
  },
  affiliateskpi: {
    name: "KPI Affiliates",
    key: "kpi-affiliates",
  },
  telesaleskpi: {
    name: "KPI Telesales",
    key: "kpi-telesales",
  },
  productivity: {
    name: "Productivity",
    key: "productivity-report",
  },
  managementkpi: {
    name: "KPI Management",
    key: "kpi-management",
  },
  revenues: {
    name: "Revenue Report",
    key: "revenue-report",
  },
  aiCallAnalysis: {
    name: "AI Call Analysis",
    key: "ai-call-analysis",
  },
  staffList: {
    name: "Staff List",
    key: "staffList",
  },
  pipelinForcasting: {
    name: "Pipeline Forcasting",
    key: "pipeline-forcasting",
  },
  pipelinOverviewKPI: {
    name: "Pipeline Overview KPI",
    key: "overview-kpi",
  },
}
export const billingCategories = () => [
  //remove?
  { key: 1, label: t("Medallion"), value: "medallion" },
  { key: 2, label: t("Non Medallion"), value: "nonMedallion" },
  { key: 2, label: t("Tripartite"), value: "tripartite" },
]

export const revenueTypes = () => [
  { key: 1, label: t("All"), value: "All" },
  { key: 2, label: t("Invoiced"), value: "invoiced" },
  { key: 3, label: t("Un-Invoiced"), value: "un-invoiced" },
]

export const adjustmentVarients = (t = () => {}) => [
  { label: t("Add"), value: 1 },
  { label: t("Subtract"), value: -1 },
]

export const browsersMappingWithIcon = () => {
  return [
    {
      key: "safari",
      icon: "IconBrowserSafari",
    },
    {
      key: "chrome",
      icon: "IconBrowserChrome",
    },
    {
      key: "firefox",
      icon: "IconBrowserFirefox",
    },
  ]
}

export const regions = () => [
  { label: t("Central"), value: "central" },
  { label: t("North"), value: "north" },
  { label: t("East"), value: "east" },
  { label: t("West"), value: "west" },
  { label: t("South"), value: "south" },
]

export const policyStatuses = () => [
  { label: t("Active"), value: "active" },
  { label: t("Inactive"), value: "in_active" },
]

export const enableOrDisableOptions = () => [
  { label: t("Yes"), value: true },
  { label: t("No"), value: false },
]

export const numberTypes = () => [
  { key: 1, label: t("Percentage"), value: "percentage" },
  {
    key: 2,
    label: t("Amount"),
    value: "fixed",
  },
]
export const relationTypes = () => [
  { key: 1, label: t("Is Greater Than"), value: ">" },
  {
    key: 2,
    label: t("Is Less Than"),
    value: "<",
  },
]

export const incentiveStatuses = () => [
  { label: t("Matured"), value: "matured" },
  { label: t("In Process"), value: "in_process" },
  { label: t("Verified"), value: "verified" },
  { label: t("Dispatch"), value: "dispatch" },
  { label: t("Disbursed"), value: "disbursed" },
]
export const poolStatuses = () => [
  { label: t("Active"), value: "1" },
  { label: t("Inactive"), value: "0" },
]

export const leadServingOptions = () => [
  { label: t("Any"), value: "any" },
  { label: t("Client Country Based"), value: "client_country_based" },
]

export const intentType = () => [
  { key: 1, label: t("Self Occupation"), value: "self_occupation" },
  { key: 2, label: t("Rental Income"), value: "rental_income" },
  { key: 3, label: t("Business Purpose"), value: "business_purpose" },
  { key: 4, label: t("Permanent Residency"), value: "permanent_residency" },
  { key: 5, label: t("General Investment"), value: "general_investment" },
]

export const financingType = (showCash = true) => [
  { key: 1, label: t("Bank Loan"), value: "mortgage" },
  { key: 2, label: t(`Self Finance${showCash ? " (Cash)" : ""}`), value: "self_finance" },
  { key: 3, label: t("Personal Loan"), value: "personal_loan" },
  { key: 4, label: t("Refinance"), value: "refinance" },
  { key: 5, label: t("Corporate Finance"), value: "corporate_finance" },
  { key: 6, label: t("Pledge"), value: "pledge" },
]

export const leadsLostTypes = () => [
  { key: 1, label: t("Show Lost Only"), value: true },
  { key: 2, label: t("Exclude Lost"), value: false },
]

export const pipelineStage = () => [
  { label: t("Prospect"), value: "prospect" },
  { label: t("Mature"), value: "matured" },
  { label: t("Pre-Closure"), value: "preclosure" },
  { label: t("Partial Sold"), value: "partialSold" },
  { label: t("Sold"), value: "sold", disabled: true },
]

export const pipelineRevenues = () => [
  { label: t("Total Revenue"), value: "total" },
  { label: t("Potential Revenue"), value: "potential" },
  { label: t("Recognized Revenue"), value: "recognized" },
  { label: t("Reported Revenue"), value: "reported" },
]

export const bonusPolicyTypes = () => [
  { value: "project_bonus", label: t("Project Bonus") },
  { value: "flat_bonus", label: t("Flat Bonus") },
  { value: "designation_bonus", label: t("Designation Bonus") },
]

export const leadsToDoTags = () => [
  { key: 1, label: t("Meeting Pushed by TSR"), value: "meeting_pushed_tsr" },
  { key: 2, label: t("Self-Assigned"), value: "self_assigned" },
  { key: 3, label: t("System Generated"), value: "system_generated" },
]

export const tsrToDoTags = () => [
  { key: 1, label: t("New Lead Sharing"), value: "new_lead_sharing" },
  { key: 2, label: t("Assigned by QC"), value: "assigned_by_qc" },
  { key: 3, label: t("Self-Assigned"), value: "self_assigned" },
]

export const staffIncentiveAmountType = () => [
  { key: 2, label: t("Hold"), value: "hold" },
  { key: 1, label: t("Partial Settled"), value: "partial_disbursal" },
  { key: 1, label: t("Full Settled"), value: "full_disbursal" },
]

export const getTaskSource = () => {
  return [
    {
      label: t("Propforce Web"),
      value: "web_v2",
    },
    {
      label: t("Propforce Mobile App"),
      value: "android_app",
    },
    {
      label: t("AI Generated"),
      value: "auto",
    },
  ]
}

export const textForUserOrAIEdited = () => ({
  auto_task_creation: t("Updated By AI"),
  edit_task: t("edited"),
})

export const getTaskUpdatedByList = () => {
  return [
    {
      label: t("Updated By Staff"),
      value: "edit_task",
    },
    {
      label: t("Updated By AI"),
      value: "auto_task_creation",
    },
  ]
}
export const relationCategories = () => {
  return [
    { label: t("S/O"), value: "S/O" },
    { label: t("D/O"), value: "D/O" },
    { label: t("W/O"), value: "W/O" },
  ]
}

export const callStatuses = () => ({
  unanswered: {
    title: "UA",
    tooltipContent: "Unanswered",
    color: theme["error-color-light"],
    textColor: theme["error-color"],
  },
  answered: {
    title: "Ans",
    tooltipContent: "Answered",
    color: theme["primary-light"],
    textColor: theme["primary-color"],
  },
  connected: {
    title: "Con",
    tooltipContent: "Connected",
    color: theme["primary-light"],
    textColor: theme["primary-color"],
  },
  rejected: { title: "Rej", tooltipContent: "Rejected", color: theme["error-color-light"], textColor: "#FFC48C" },
  missed: { title: "Mis", tooltipContent: "Missed", color: theme["error-color-light"], textColor: "#F28B82" },
})

export const rulesStatus = () => [
  { label: t("Active"), value: 1 },
  { label: t("Inactive"), value: 0 },
]

export const unitConstructionPhases = () => [
  { label: t("Ready Made Unit"), value: "completed" },
  { label: t("Off Plan"), value: "under-construction" },
]

export const saleStaffStatus = () => [
  { label: t("Available"), value: "available" },
  { label: t("Not Available"), value: "unavailable" },
  { label: t("In Meeting"), value: "in_meeting" },
]

export const allocationTypes = () => [
  { label: t("New Lead"), value: "new" },
  { label: t("Shifted/Re-Allocated Leads"), value: "shifted" },
]

export const autoGenerateBookingFormStatuses = () => [
  { label: t("Token"), value: "token_payment" },
  { label: t("PDP"), value: "partial_down_payment" },
  { label: t("CDP"), value: "complete_down_payment" },
]

export const leadAgainstTypes = () => [
  { id: 1, label: t("Project"), value: "project" },
  { id: 4, label: t("Partner"), value: "partner" },
]

export const ratingsOption = () => [
  { value: 1, label: t("1") },
  { value: 2, label: t("2") },
  { value: 3, label: t("3") },
  { value: 4, label: t("4") },
  { value: 5, label: t("5") },
  { value: 6, label: t("6") },
  { value: 7, label: t("7") },
  { value: 8, label: t("8") },
  { value: 9, label: t("9") },
  { value: 10, label: t("10") },
]

export const defaultCity = {
  PK: {
    default_city: "Lahore",
  },
  SA: {
    default_city: "Riyadh",
  },
}

export const staffAllocationTypes = () => {
  return [
    { key: 1, label: t("Auto"), value: "auto" },
    { key: 2, label: t("Manual"), value: "manual" },
  ]
}

export const signupPlatforms = () => [
  { value: "mobile", label: t("Mobile") },
  { value: "web", label: t("Web") },
]

export const lowPerformanceDocumentTitles = () => ({
  low_performance_warning_one: t("First Warning Letter"),
  low_performance_warning_two: t("Second Warning Letter"),
  investigation: t("Investigation Notice"),
})
export const businessModelTypes = () => [
  { id: 1, label: t("Primary"), value: "primary" },
  { id: 2, label: t("Secondary"), value: "secondary" },
]

export const evaluationTypes = () => [
  { key: 1, label: t("AI Evaluated"), value: "ai" },
  { key: 2, label: t("Manually Evaluated"), value: "manual" },
]

export const syncStatuses = () => [
  { key: 1, label: t("Synced"), value: "synced" },
  { key: 2, label: t("Not Synced"), value: "unsynced" },
]

export const externalLeadsSyncStatus = () => [
  { key: 1, label: t("Successful"), value: "successful" },
  { key: 2, label: t("In Progress"), value: "pending" },
  { key: 3, label: t("Failed"), value: "failed" },
]

export const affiliateSubTypes = () => [
  { label: t("Team Manager"), value: "manager" },
  { label: t("Sales Agent"), value: "staff" },
]

export const workDaysList = () => [
  { id: 1, label: t("Mon"), value: "Weekday1" },
  { id: 2, label: t("Tue"), value: "Weekday2" },
  { id: 3, label: t("Wed"), value: "Weekday3" },
  { id: 4, label: t("Thu"), value: "Weekday4" },
  { id: 5, label: t("Fri"), value: "Weekday5" },
  { id: 6, label: t("Sat"), value: "Weekday6" },
  { id: 7, label: t("Sun"), value: "Weekday7" },
]
export const saleTypeOptions = () => [
  {
    label: t("Bank Loan"),
    value: "mortgage",
  },
  {
    label: t("Self Finance (Cash)"),
    value: "self_finance",
  },
]

export const bookingFormStatuses = () => [
  { key: 1, label: t("Draft"), value: "draft" },
  { key: 2, label: t("Completed"), value: "completed" },
  { key: 3, label: t("Signed"), value: "signed" },
  { key: 4, label: t("Cancelled"), value: "cancelled" },
  { key: 5, label: t("SPA Issued"), value: "spa_issued" },
]

export const contractStatuses = () => [
  { key: 1, label: t("Draft"), value: "draft" },
  { key: 2, label: t("Pending"), value: "pending" },
  { key: 3, label: t("Signed"), value: "signed" },
  { key: 4, label: t("Cancelled"), value: "cancelled" },
]

export const AreaOptions = () => [
  {
    name: "675 Square Feet",
    value: 675,
    unit: "Square Feet",
  },
  {
    name: "1125 Square Feet",
    value: 1125,
    unit: "Square Feet",
  },
  {
    name: "1800 Square Feet",
    value: 1800,
    unit: "Square Feet",
  },
  {
    name: "2250 Square Feet",
    value: 2250,
    unit: "Square Feet",
  },
  {
    name: "4500 Square Feet",
    value: 4500,
    unit: "Square Feet",
  },
  {
    name: "9000.01 Square Feet",
    value: 9000.01,
    unit: "Square Feet",
  },
]
